import React from "react";
import { Modal, Table } from "antd";

const CostomerItem = ({ visible, onClose, onRowClick, data1 }) => {
  console.log(data1);
  const columns = [
    { title: "Contract Code", dataIndex: "sauda_code", key: "sauda_code" },
    {
      title: "Item",
      dataIndex: "item_desc",
      key: "item_desc",
    },
    { title: "Grade", dataIndex: "quality_desc", key: "quality_desc" },
    { title: "Contract Qty", dataIndex: "pending_qty", key: "pending_qty" },
    { title: "Contract Rate", dataIndex: "sauda_rate", key: "sauda_rate" },
  ];

  return (
    <Modal
      title="Select Here"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={900}
    >
      <Table
        dataSource={data1}
        columns={columns}
        onRow={(record) => {
          return {
            onClick: () => {
              onRowClick(record);
              onClose();
            },
          };
        }}
      />
    </Modal>
  );
};

export default CostomerItem;
